import { Breadcrumb } from "@redotech/redo-web/breadcrumb";
import { createContext, Dispatch, SetStateAction } from "react";

export type DocumentTitleOverriders = Map<
  string,
  (breadcrumb: Breadcrumb[]) => string
>;

const defaultDocumentTitleOverriders = new Map();

export const DocumentTitleOverridersContext = createContext<
  [DocumentTitleOverriders, Dispatch<SetStateAction<DocumentTitleOverriders>>]
>([defaultDocumentTitleOverriders, () => {}]);
